module.exports = __webpack_public_path__ + "fbf1f0dbeaac505f9cd7bbaf7bf67925.MP3";